import {SystemAlertsService} from "./service/SystemAlertsService";
import {SystemAlertStore} from "./store/SystemAlertStore";
import {systemAlertComponent, SystemAlertComponent} from "./component/SystemAlertComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.system-alerts`;

    return angular.module(moduleName, [])
                  .component(SystemAlertComponent, systemAlertComponent())
                  .service(SystemAlertsService.id, SystemAlertsService)
                  .service(SystemAlertStore.id, SystemAlertStore)
                  .name;
}
